import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./auth";
import userSlice from "./user";
import eventSlice from "./eventList"
import printerSlice from "./printer"
import kioskSlice from "./kiosk"

const rootReducer = combineReducers({
    auth: authSlice,
    user: userSlice,
    events:eventSlice,
    printer:printerSlice,
    kiosk: kioskSlice
});
export default rootReducer;
